import { render } from "./AssignSVGsModal.vue?vue&type=template&id=7e27db1e&scoped=true"
import script from "./AssignSVGsModal.vue?vue&type=script&lang=js"
export * from "./AssignSVGsModal.vue?vue&type=script&lang=js"

import "./AssignSVGsModal.vue?vue&type=style&index=0&id=7e27db1e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e27db1e"]])

export default __exports__